export const getCompany = state => state.company

export const getCompanyCurrency = state => {
  const data = {
    code: 'MYR',
    symbol: 'RM',
    multiplier: 100,
    exponent: 2
  }
  const company = state.company
  if (company && company.currency) {
    data.code = company.currency.currency_code
    data.multiplier = company.currency.currency_sub_unit
    data.exponent = company.currency.currency_sub_unit.toString().length - 1
    data.symbol = company.currency.currency_symbol
  }
  return data
}
